/**
 * @file: withErrorHandler.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export const withErrorHandler = <T>(
  factory: () => T,
  handler: ((error: unknown) => T | undefined) | ((error: unknown) => void),
) => {
  try {
    return factory();
  } catch (e) {
    return handler(e);
  }
};
